













































import DossierLabels from "./../DossierLabels.js";
import Vue, { PropType } from "vue";
import { Overige } from "../../../types/dossier/data/Overige";

export default Vue.extend({
  name: "overige-view",
  props: {
    overige: {
      type: Object as PropType<Overige>,
      required: true,
    },
    hiddenFieldsMap: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      labels: DossierLabels.overige,
    };
  },
  methods: {
    formatIBAN(iban: string): string {
      return (iban || "").replace(/(\w{4})/g, "$1 ").trim();
    },
  },
});
